let software: publication[]  = [
    {
        title: "lefschetz-family",
        date: undefined,
        status: undefined,
        url: "https://github.com/ericpipha/lefschetz-family",
        // img_url: new URL("./../imgs/lefschetz_family.png", import.meta.url).toString(),
        abstract: "This SageMath package implements the methods of my papers for the numerical computation of periods of hypersurfaces, elliptic surfaces, degree 2 K3 surfaces and more, with high certified precision. It also provides code for computing monodromy representations of families of generically smooth hypersurfaces."
    },
    {
        title: "Topological data of Calabi-Yau operators",
        date: undefined,
        status: undefined,
        url: "https://github.com/ericpipha/CYO_topological_data",
        abstract: "Data and software for (heuristically) computing topological data of Calabi-Yau operators."
    },
    {
        title: "Galois groups of crystallographic surfaces",
        date: undefined,
        status: undefined,
        url: "https://github.com/ericpipha/Galois-Groups-of-cubic-surfaces-supporting-data/",
        abstract: "This database contains a list of monodromy groups in the spaces of cubic and quartic surfaces with equations that are invariant under a finite group of linear automorphisms of the ambiant projective space."
    },
    {
        title: "CYCluster",
        date: undefined,
        status: undefined,
        url: "https://cycluster.mpim-bonn.mpg.de/",
        abstract: "This database contains a list of Calabi-Yau operators and associated data."
    }
]

export default software